// Get Shopify Product Variants
export const GET_SHOPIFY_PRODUCT_VARIANTS_REQUEST = 'GET_SHOPIFY_PRODUCT_VARIANTS_REQUEST';
export const GET_SHOPIFY_PRODUCT_VARIANTS_DONE = 'GET_SHOPIFY_PRODUCT_VARIANTS_DONE';
export const GET_SHOPIFY_PRODUCT_VARIANTS_FAILED = 'GET_SHOPIFY_PRODUCT_VARIANTS_FAILED';
export const GET_SHOPIFY_PRODUCT_VARIANTS_RESET = 'GET_SHOPIFY_PRODUCT_VARIANTS_RESET';
